import { createEnv } from "@t3-oss/env-core";
import { z } from "zod/v4";

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_VOLUME_URL: z.url(),
    VITE_MERCHANT_PORTAL_BACKEND_URL: z.url(),
    VITE_VOLUME_ZAPIER_HOOK: z.url(),
    VITE_SIGNUP_EMAIL: z.email(),
    VITE_SIGNUP_PASSWORD: z.string(),
    VITE_DATADOG_CLIENT_TOKEN: z.string(),
    VITE_DATADOG_RUM_APPLICATION_ID: z.string(),
    VITE_IS_LOCAL: z
      .boolean()
      .optional()
      .default(import.meta.env.DEV),
    VITE_IS_PLAYWRIGHT: z
      .string()
      .optional()
      .default("false")
      .transform((v) => v === "true"),
    VITE_IS_DEMO: z
      .string()
      .optional()
      .default("false")
      .transform((v) => v === "true"),
    VITE_PUBLIC_POSTHOG_KEY: z.string(),
    VITE_PUBLIC_POSTHOG_HOST: z.string().default("/hjkl-asdf"),
    VITE_PUBLIC_TRANSACTION_MONITORING_API_URL: z.url().optional(),
    VITE_TRANSACTION_MONITORING_API_URL: z.url().optional(),
    VITE_TRANSACTION_MONITORING_E2E_BYPASS: z.string().optional(),
    // VITE_SIGNUP_EMAIL: z.string().email(),
    // VITE_SIGNUP_PASSWORD: z.string(),
  },
  // @ts-expect-error -- Ignore or fix by adding vite .d.ts
  runtimeEnvStrict: import.meta.env,
  skipValidation: import.meta.env.MODE === "test",
});
